// The list a detail page was opened from, carried in the history entry's state rather than the URL (IMM-1347):
// the same Deal is reached from „Aufträge" and from the Akquise-Pipeline, and only the first should light „Aufträge".
export const NAV_ORIGINS = ['mandates', 'prospects'] as const;
export type NavOrigin = (typeof NAV_ORIGINS)[number];
export type NavOriginState = { readonly navOrigin: NavOrigin };

export const navOriginState = (navOrigin: NavOrigin): NavOriginState => ({ navOrigin });

// `location.state` is whatever the last navigation put there, so it is narrowed, never cast.
export function readNavOrigin(state: unknown): NavOrigin | null {
  if (typeof state !== 'object' || state === null || !('navOrigin' in state)) return null;

  const { navOrigin } = state as { readonly navOrigin: unknown };

  return NAV_ORIGINS.find((origin) => origin === navOrigin) ?? null;
}
